import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`temporary_registration_vul_list`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  async matchingList(screenId, payload) {
    return await repository.post(
      `temporary_registration_vul_matching_list`,
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async update(screenId, payload) {
    return await repository.post(
      `temporary_registration_vul_confirm`,
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
